import { z } from 'zod';
import { optionalNonNegativeNumberString, requiredUuidString } from '../zod-helpers/index.js';
import { PRODUCT_CONSTRAINTS } from './constraints.js';
export const productFormFieldsSchema = z.object({
    num: z
        .string()
        .trim()
        .min(1, `${PRODUCT_CONSTRAINTS.num.label} is required.`)
        .max(PRODUCT_CONSTRAINTS.num.maxLength),
    brandId: requiredUuidString('Brand is required.', 'Invalid brand selection.'),
    uomId: requiredUuidString('UOM is required.', 'Invalid UOM selection.'),
    name: z.string().max(PRODUCT_CONSTRAINTS.name.maxLength),
    description: z.string().trim().max(PRODUCT_CONSTRAINTS.description.maxLength),
    price: optionalNonNegativeNumberString('Product price'),
    sku: z.string().max(PRODUCT_CONSTRAINTS.sku.maxLength),
    upc: z.string().max(PRODUCT_CONSTRAINTS.upc.maxLength),
});
export const productCreateFormSchema = productFormFieldsSchema.extend({
    partId: requiredUuidString('Part is required.', 'Invalid part selection.'),
});
export const emptyProductFormValues = () => ({
    num: '',
    brandId: '',
    uomId: '',
    name: '',
    description: '',
    price: '',
    sku: '',
    upc: '',
});
export const emptyProductCreateFormValues = () => ({
    ...emptyProductFormValues(),
    partId: '',
});
//# sourceMappingURL=create-form.js.map